import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "signup"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "inner" };
const _hoisted_7 = {
    key: 0,
    class: "err"
};
const _hoisted_8 = { class: "recap" };
const _hoisted_9 = { class: "bt_box" };
const _hoisted_10 = { class: "b_max" };
const _hoisted_11 = ["disabled"];
import { ref, watch } from 'vue';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import InertiaUtil from '@util/InertiaUtil';
import { PlanCategory, UserType } from '@util/Consts';
import RecaptchaForm from '@component/RecaptchaForm.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'signup',
    props: {
        common: {},
        type: {},
        plan_id: {},
        errors: {}
    },
    setup(__props) {
        var _a, _b;
        const props = __props;
        // 送信ボタンの活性/非活性判定
        const disabled = ref(true);
        const form = InertiaUtil.getForm({
            email: '',
            type: (_a = props.type) !== null && _a !== void 0 ? _a : UserType.TEMPORARY_REGISTRATION,
            plan_id: (_b = props.plan_id) !== null && _b !== void 0 ? _b : PlanCategory.FREE_PLAN,
            // recaptcha: '',
        }, props.common.path);
        // 文字数チェック
        watch(() => form.email, (value) => {
            if (Alert.charLimitText(value)) {
                form.email = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        const onVerify = (response) => {
            // form.recaptcha = response;
            disabled.value = false;
        };
        const onExpired = () => {
            // form.recaptcha = '';
            disabled.value = true;
        };
        const onError = () => {
            // form.recaptcha = '';
            disabled.value = true;
        };
        const onSubmit = () => {
            InertiaUtil.post(form, route('signup.store'));
        };
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common,
                    type: props.type
                }, null, 8, ["common", "type"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            (props.type == _unref(UserType).MENTOR)
                                ? (_openBlock(), _createElementBlock("h2", _hoisted_4, "メンター申請登録"))
                                : (_openBlock(), _createElementBlock("h2", _hoisted_5, "新規会員登録")),
                            _createElementVNode("div", _hoisted_6, [
                                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "lead" }, [
                                    _createElementVNode("a", {
                                        href: "/terms",
                                        target: "_blank",
                                        class: "sign-line"
                                    }, "利用規約"),
                                    _createTextVNode(" と "),
                                    _createElementVNode("a", {
                                        href: "/policy",
                                        target: "_blank",
                                        class: "sign-line"
                                    }, "プライバシーポリシー"),
                                    _createTextVNode("に同意の上、ご登録ください。 ")
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(onSubmit, ["prevent"]),
                                    class: "signup-form"
                                }, [
                                    _createElementVNode("dl", null, [
                                        _cache[1] || (_cache[1] = _createElementVNode("dt", null, "メール", -1)),
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).email) = $event)),
                                                class: "wmax",
                                                type: "email",
                                                placeholder: "例：info@sharementors.jp",
                                                autofocus: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(form).email]
                                            ])
                                        ])
                                    ]),
                                    ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.email)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(props.errors.email), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createVNode(RecaptchaForm, {
                                            class: "inner",
                                            onVerify: onVerify,
                                            onExpired: onExpired,
                                            onError: onError
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("ul", null, [
                                            _createElementVNode("li", _hoisted_10, [
                                                _createElementVNode("button", {
                                                    type: "submit",
                                                    id: "submit-button",
                                                    value: "送信確認",
                                                    disabled: disabled.value
                                                }, "同意して会員登録する", 8, _hoisted_11)
                                            ])
                                        ])
                                    ])
                                ], 32)
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
